/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-throw-literal */
/* eslint-disable @ts-nocheck */
//
// Copyright (c) 2018 - Karthik Bashetty - https://codepen.io/abruzzi/pen/EpqaH
// https://blog.codepen.io/legal/licensing/
//
// Permission is hereby granted, free of charge, to any person
// obtaining a copy of this software and associated documentation
// files (the "Software"), to deal in the Software without restriction,
//  including without limitation the rights to use, copy, modify,
// merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall
// be included in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
// EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
// OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
// NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
// HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
// WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
// DEALINGS IN THE SOFTWARE.

import videojs from 'video.js';

var version = '0.0.0';

// A hand-rolled, tiny jQuery implementation.
const $$ = function (selectorOrElements) {
  let elements =
    typeof selectorOrElements === 'object'
      ? selectorOrElements
      : [...document.querySelectorAll(selectorOrElements)];

  if (!Array.isArray(elements)) {
    elements = [elements];
  }

  const wrapper = {
    on: (type, handler) => {
      elements.forEach((el) => {
        el.addEventListener(type, handler);

        el.$$_handlers = el.$$_handlers || {};
        el.$$_handlers[type] = el.$$_handlers[type] || [];
        el.$$_handlers[type].push(handler);
      });

      return wrapper;
    },

    off: (type, handler) => {
      elements.forEach((el) => {
        el.$$_handlers = el.$$_handlers || {};

        if (handler) {
          el.removeEventListener(type, handler);
        } else {
          (el.$$_handlers[type] || []).forEach((handler) => {
            el.removeEventListener(type, handler);
          });
        }

        el.$$_handlers[type] = [];
      });

      return wrapper;
    },

    width: () => {
      return elements[0] ? elements[0].offsetWidth : NaN;
    },

    height: () => {
      return elements[0] ? elements[0].offsetHeight : NaN;
    },

    offset: () => {
      const rect = elements[0].getBoundingClientRect();

      return {
        top: rect.top + document.body.scrollTop + window.scrollY,
        left: rect.left + document.body.scrollLeft + window.scrollX,
      };
    },

    children: (selector) => {
      const childElements = elements
        .map((el) => [...el.querySelectorAll(selector)])
        .reduce((a, b) => a.concat(b), []);

      return $$(childElements);
    },

    css: (attr, decl) => {
      if (typeof attr === 'string') {
        const style = decl + (typeof decl === 'number' ? 'px' : '');
        elements.forEach((el) => (el.style[attr] = style));
      } else {
        Object.keys(attr).forEach((key) => {
          wrapper.css(key, attr[key]);
        });
      }

      return wrapper;
    },
  };

  return wrapper;
};

// Default options for the plugin.
var defaults = {};

// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;
// const dom = videojs.dom || videojs;

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */
var onPlayerReady = function onPlayerReady(player, options) {
  player.addClass('vjs-crop');
};

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a 'ready' state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for 'ready'!
 *
 * @function crop
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
var cropPlugin = function cropPlugin(options) {
  var _this = this;

  if (!options) {
    options = {};
  }
  this.ready(function () {
    onPlayerReady(_this, videojs.mergeOptions(defaults, options));
  });
  var player = this;
  player.crop = new Crop(player, options);

  if (isDefined(options.minHeight)) player.crop.minHeight = options.minHeight;
  if (isDefined(options.minWidth)) player.crop.minWidth = options.minWidth;

  if (isDefined(options.videoWidth)) player.crop.videoWidth = options.videoWidth;
  if (isDefined(options.videoHeight)) player.crop.videoHeight = options.videoHeight;

  if (isDefined(options.height)) player.crop.height = options.height;
  if (isDefined(options.width)) player.crop.width = options.width;
  if (isDefined(options.top)) player.crop.top = options.top;
  if (isDefined(options.left)) player.crop.left = options.left;

  player.crop.hide();
};

var Crop = function Crop(player, options) {
  this.draglock = false;

  this.components = {};

  this.player = player;

  this.components.cropContainer = player.getChild('CropContainer');
  this.components.cropBox = this.components.cropContainer.getChild('CropBox');

  return this;
};

Crop.prototype.show = function () {
  this.initComponents();
  this.components.cropContainer.show();
  this.components.cropContainer.triggerMovedEvent();
  this.enabled = true;
};

Crop.prototype.initComponents = function () {
  for (var component in this.components) {
    this.components[component].init_();
  }
};

Crop.prototype.hide = function () {
  this.components.cropContainer.hide();
  this.components.cropContainer.unbind();
  this.enabled = false;
};

Crop.prototype.resize = function (width, height) {
  this.videoWidth = width;
  this.videoHeight = height;

  if (this.enabled) {
    this.components.cropContainer.unbind();
    this.show();
  }
};

Crop.prototype.getWidth = function () {
  return getComputedStyle(this.components.cropBox.el_).width;
};

Crop.prototype.getHeight = function () {
  return getComputedStyle(this.components.cropBox.el_).height;
};

Crop.prototype.getX = function () {
  var left = parseFloat(getComputedStyle(this.components.cropBox.el_).left) - this.horizontalOffset;
  if (left < 0) left = 0;
  return left + 'px';
};

Crop.prototype.getY = function () {
  var top = parseFloat(getComputedStyle(this.components.cropBox.el_).top) - this.verticalOffset;
  if (top < 0) top = 0;
  return top + 'px';
};

Crop.prototype.getPlayerWidth = function () {
  return parseFloat(getComputedStyle(this.player.el_).width) - 2 * this.horizontalOffset;
};

Crop.prototype.getPlayerHeight = function () {
  return parseFloat(getComputedStyle(this.player.el_).height) - 2 * this.verticalOffset;
};

// Add components to dom

videojs.getComponent('Player').prototype.options_.children.push('CropContainer');

// Create new components

var videojsComponent = videojs.getComponent('Component');

var CropContainer = videojs.extend(videojsComponent, {
  constructor: function constructor(player, options) {
    videojsComponent.call(this, player, options);
    this.onMouseMoveCallback = this.onMouseMove.bind(this);
    this.onMouseUpCallback = this.onMouseUp.bind(this);
  },
});

CropContainer.prototype.init_ = function () {
  this.crop = this.player_.crop;
  this.playerWidth = parseFloat(getComputedStyle(this.player_.el()).width);
  this.playerHeight = parseFloat(getComputedStyle(this.player_.el()).height);
  this.playerLeft = 0;
  this.playerTop = 0;
  this.crop = this.player_.crop;
  this.crop.horizontalOffset = 0;

  if (this.crop.videoWidth && this.crop.videoHeight) {
    var playerAspectRatio = parseFloat((this.playerWidth / this.playerHeight).toFixed(2));
    var videoAspectRatio = parseFloat((this.crop.videoWidth / this.crop.videoHeight).toFixed(2));

    var horizontalOffset = 0;
    var verticalOffset = 0;
    if (isDefined(playerAspectRatio) && isDefined(videoAspectRatio)) {
      if (playerAspectRatio > videoAspectRatio) {
        //video is aligned in portrait mode wrt. the player
        var videoWidth = (this.crop.videoWidth * this.playerHeight) / this.crop.videoHeight;
        horizontalOffset = (this.playerWidth - videoWidth) / 2;
        if (videoWidth > this.playerWidth) {
          horizontalOffset = 0;
          videoWidth = this.playerWidth;
        }
        this.playerWidth = videoWidth;
      } else if (playerAspectRatio < videoAspectRatio) {
        //video is aligned in landscape mode wrt. the player
        var videoHeight = (this.crop.videoHeight * this.playerWidth) / this.crop.videoWidth;
        verticalOffset = (this.playerHeight - videoHeight) / 2;
        if (videoHeight > this.playerHeight) {
          verticalOffset = 0;
          videoHeight = this.playerHeight;
        }
        this.playerHeight = videoHeight;
      }
    }
    this.crop.horizontalOffset = horizontalOffset;
    this.crop.verticalOffset = verticalOffset;
    this.playerLeft += horizontalOffset;
    this.playerTop += verticalOffset;
  }

  this.el_.style['width'] = getComputedStyle(this.player_.el()).width;
  this.el_.style['height'] = getComputedStyle(this.player_.el()).height;
  this.crop.containerOffsetLeft = $$(this.el_).offset().left;
  this.crop.containerOffsetTop = $$(this.el_).offset().top;
  this.crop.maxCropWidth = getComputedStyle(this.player_.el()).width;
  this.crop.maxCropHeight = getComputedStyle(this.player_.el()).height;
  this.crop.leftFillDiv = $$(this.el_).children('.vjs-crop-box-left');
  this.crop.rightFillDiv = $$(this.el_).children('.vjs-crop-box-right');
  this.crop.topFillDiv = $$(this.el_).children('.vjs-crop-box-top');
  this.crop.bottomFillDiv = $$(this.el_).children('.vjs-crop-box-bottom');
  this.bind();
};

CropContainer.prototype.bind = function () {
  $$(document).on('mousemove', this.onMouseMoveCallback);
  $$(document).on('mouseup', this.onMouseUpCallback);
};

CropContainer.prototype.unbind = function () {
  $$(document).off('mousemove', this.onMouseMoveCallback);
  $$(document).off('mouseup', this.onMouseUpCallback);
};

CropContainer.prototype.options_ = {
  children: {
    CropBox: {},
  },
};

CropContainer.prototype.createEl = function () {
  return videojsComponent.prototype.createEl.call(this, 'div', {
    className: 'vjs-crop-container',
    innerHTML:
      '<div class="vjs-crop-box-left"></div>' +
      '<div class="vjs-crop-box-top"></div>' +
      '<div class="vjs-crop-box-right"></div>' +
      '<div class="vjs-crop-box-bottom"></div>',
  });
};

CropContainer.prototype.onMouseMove = function (event) {
  this.crop.windowPointX = event.pageX;
  this.crop.windowPointY = event.pageY;
  if (this.crop.draglock === true) {
    this.calTransformCube();
    this.triggerMovedEvent();
  }
};

CropContainer.prototype.triggerMovedEvent = function () {
  var playerWidth = parseFloat(this.crop.getPlayerWidth());
  var playerHeight = parseFloat(this.crop.getPlayerHeight());

  // Getting crop box dimensions
  var cropX = (parseFloat(this.crop.getX()) * 100) / playerWidth;
  var cropY = (parseFloat(this.crop.getY()) * 100) / playerHeight;
  var cropWidth = (parseFloat(this.crop.getWidth()) * 100) / playerWidth;
  var cropHeight = (parseFloat(this.crop.getHeight()) * 100) / playerHeight;

  this.player_.trigger('CropControlsMoved', { cropX, cropY, cropWidth, cropHeight });
};

CropContainer.prototype.calTransformCube = function () {
  var destHeight = 0;
  var destWidth = 0;
  var destTop = 0;
  var destLeft = 0;
  var diff = 0;
  var cube = this.getChild('CropBox').el_;
  switch (this.crop.currentDirection) {
    case 'n':
      this.crop.cubeTransformHeight = this.crop.windowPointY - this.crop.mousedownPointY;
      destHeight = this.crop.cubeCurrentHeight - this.crop.cubeTransformHeight;
      destTop = this.crop.cubeCurrentTop + this.crop.cubeTransformHeight;
      if (destTop < this.playerTop) {
        diff = this.crop.cubeCurrentTop - this.crop.verticalOffset;
        destTop = this.playerTop;
        destHeight = this.crop.cubeCurrentHeight + diff;
      } else if (destHeight < this.crop.minHeight) {
        diff = this.crop.cubeCurrentHeight - this.crop.minHeight;
        destHeight = this.crop.minHeight;
        destTop = this.crop.cubeCurrentTop + diff;
      }
      $$(cube).css({
        height: destHeight,
        top: destTop,
      });
      break;
    case 'e':
      this.crop.cubeTransformWidth = this.crop.windowPointX - this.crop.mousedownPointX;
      destWidth = this.crop.cubeCurrentWidth + this.crop.cubeTransformWidth;
      if (destWidth + this.crop.cubeCurrentLeft > this.playerLeft + this.playerWidth) {
        destWidth = this.playerLeft + this.playerWidth - this.crop.cubeCurrentLeft;
      } else if (destWidth < this.crop.minWidth) {
        destWidth = this.crop.minWidth;
      }
      $$(cube).css({
        width: destWidth,
      });
      break;
    case 's':
      this.crop.cubeTransformHeight = this.crop.windowPointY - this.crop.mousedownPointY;
      destHeight = this.crop.cubeCurrentHeight + this.crop.cubeTransformHeight;
      if (destHeight + this.crop.cubeCurrentTop > this.playerTop + this.playerHeight) {
        destHeight = this.playerTop + this.playerHeight - this.crop.cubeCurrentTop;
      } else if (destHeight < this.crop.minHeight) {
        destHeight = this.crop.minHeight;
      }
      $$(cube).css({
        height: destHeight,
      });
      break;
    case 'w':
      this.crop.cubeTransformWidth = this.crop.windowPointX - this.crop.mousedownPointX;
      destWidth = this.crop.cubeCurrentWidth - this.crop.cubeTransformWidth;
      destLeft = this.crop.cubeCurrentLeft + this.crop.cubeTransformWidth;
      if (destLeft < this.playerLeft) {
        diff = this.crop.cubeCurrentLeft - this.playerLeft;
        destLeft = this.playerLeft;
        destWidth = this.crop.cubeCurrentWidth + diff - this.playerLeft;
      } else if (destWidth < this.crop.minWidth) {
        diff = this.crop.cubeCurrentWidth - this.crop.minWidth;
        destWidth = this.crop.minWidth;
        destLeft = this.crop.cubeCurrentLeft + diff;
      }
      $$(cube).css({
        width: destWidth,
        left: destLeft,
      });
      break;
    case 'nw':
      this.crop.cubeTransformHeight = this.crop.windowPointY - this.crop.mousedownPointY;
      this.crop.cubeTransformWidth = this.crop.windowPointX - this.crop.mousedownPointX;
      destHeight = this.crop.cubeCurrentHeight - this.crop.cubeTransformHeight;
      destWidth = this.crop.cubeCurrentWidth - this.crop.cubeTransformWidth;
      destTop = this.crop.cubeCurrentTop + this.crop.cubeTransformHeight;
      destLeft = this.crop.cubeCurrentLeft + this.crop.cubeTransformWidth;

      if (destTop < this.playerTop) {
        diff = this.crop.cubeCurrentTop - this.crop.verticalOffset;
        destTop = this.playerTop;
        destHeight = this.crop.cubeCurrentHeight + diff;
      } else if (destHeight < this.crop.minHeight) {
        diff = this.crop.cubeCurrentHeight - this.crop.minHeight;
        destHeight = this.crop.minHeight;
        destTop = this.crop.cubeCurrentTop + diff;
      }
      $$(cube).css({
        height: destHeight,
        top: destTop,
      });
      if (destLeft < this.playerLeft) {
        diff = this.crop.cubeCurrentLeft - this.playerLeft;
        destLeft = this.playerLeft;
        destWidth = this.crop.cubeCurrentWidth + diff;
      } else if (destWidth < this.crop.minWidth) {
        diff = this.crop.cubeCurrentWidth - this.crop.minWidth;
        destWidth = this.crop.minWidth;
        destLeft = this.crop.cubeCurrentLeft + diff;
      }
      $$(cube).css({
        width: destWidth,
        left: destLeft,
      });
      break;
    case 'se':
      this.crop.cubeTransformHeight = this.crop.windowPointY - this.crop.mousedownPointY;
      this.crop.cubeTransformWidth = this.crop.windowPointX - this.crop.mousedownPointX;
      destHeight = this.crop.cubeCurrentHeight + this.crop.cubeTransformHeight;
      destWidth = this.crop.cubeCurrentWidth + this.crop.cubeTransformWidth;
      if (destHeight + this.crop.cubeCurrentTop > this.playerTop + this.playerHeight) {
        destHeight = this.playerTop + this.playerHeight - this.crop.cubeCurrentTop;
      } else if (destHeight < this.crop.minHeight) {
        destHeight = this.crop.minHeight;
      }
      $$(cube).css({
        height: destHeight,
      });
      if (destWidth + this.crop.cubeCurrentLeft > this.playerLeft + this.playerWidth) {
        destWidth = this.playerLeft + this.playerWidth - this.crop.cubeCurrentLeft;
      } else if (destWidth < this.crop.minWidth) {
        destWidth = this.crop.minWidth;
      }
      $$(cube).css({
        width: destWidth,
      });
      break;
    case 'ne':
      this.crop.cubeTransformHeight = this.crop.windowPointY - this.crop.mousedownPointY;
      this.crop.cubeTransformWidth = this.crop.windowPointX - this.crop.mousedownPointX;
      destHeight = this.crop.cubeCurrentHeight - this.crop.cubeTransformHeight;
      destWidth = this.crop.cubeCurrentWidth + this.crop.cubeTransformWidth;
      destTop = this.crop.cubeCurrentTop + this.crop.cubeTransformHeight;
      if (destTop < this.playerTop) {
        diff = this.crop.cubeCurrentTop - this.crop.verticalOffset;
        destTop = this.playerTop;
        destHeight = this.crop.cubeCurrentHeight + diff;
      } else if (destHeight < this.crop.minHeight) {
        diff = this.crop.cubeCurrentHeight - this.crop.minHeight;
        destHeight = this.crop.minHeight;
        destTop = this.crop.cubeCurrentTop + diff;
      }
      $$(cube).css({
        height: destHeight,
        top: destTop,
      });
      if (destWidth + this.crop.cubeCurrentLeft > this.playerLeft + this.playerWidth) {
        destWidth = this.playerLeft + this.playerWidth - this.crop.cubeCurrentLeft;
      } else if (destWidth < this.crop.minWidth) {
        destWidth = this.crop.minWidth;
      }
      $$(cube).css({
        width: destWidth,
      });
      break;
    case 'sw':
      this.crop.cubeTransformHeight = this.crop.windowPointY - this.crop.mousedownPointY;
      this.crop.cubeTransformWidth = this.crop.windowPointX - this.crop.mousedownPointX;
      destHeight = this.crop.cubeCurrentHeight + this.crop.cubeTransformHeight;
      destWidth = this.crop.cubeCurrentWidth - this.crop.cubeTransformWidth;
      destLeft = this.crop.cubeCurrentLeft + this.crop.cubeTransformWidth;
      if (destHeight + this.crop.cubeCurrentTop > this.playerTop + this.playerHeight) {
        destHeight = this.playerTop + this.playerHeight - this.crop.cubeCurrentTop;
      } else if (destHeight < this.crop.minHeight) {
        destHeight = this.crop.minHeight;
      }
      $$(cube).css({
        height: destHeight,
      });
      if (destLeft < this.playerLeft) {
        diff = this.crop.cubeCurrentLeft - this.playerLeft;
        destLeft = this.playerLeft;
        destWidth = this.crop.cubeCurrentWidth + diff;
      } else if (destWidth < this.crop.minWidth) {
        diff = this.crop.cubeCurrentWidth - this.crop.minWidth;
        destWidth = this.crop.minWidth;
        destLeft = this.crop.cubeCurrentLeft + diff;
      }
      $$(cube).css({
        width: destWidth,
        left: destLeft,
      });
      break;
    case 'centered':
      this.crop.cubeTransformHeight = this.crop.windowPointY - this.crop.mousedownPointY;
      this.crop.cubeTransformWidth = this.crop.windowPointX - this.crop.mousedownPointX;
      destTop = this.crop.cubeCurrentTop + this.crop.cubeTransformHeight;
      destLeft = this.crop.cubeCurrentLeft + this.crop.cubeTransformWidth;
      if (destTop < this.playerTop) {
        destTop = this.playerTop;
      } else if (destTop + this.crop.cubeCurrentHeight > this.playerHeight + this.playerTop) {
        destTop = this.playerHeight + this.playerTop - this.crop.cubeCurrentHeight;
      }
      if (destLeft < this.playerLeft) {
        destLeft = this.playerLeft;
      } else if (destLeft + this.crop.cubeCurrentWidth > this.playerWidth + this.playerLeft) {
        destLeft = this.playerWidth + this.playerLeft - this.crop.cubeCurrentWidth;
      }
      $$(cube).css({
        top: destTop,
        left: destLeft,
      });
      break;
    default:
      throw 'direction error';
  }
  this.crop.leftFillDiv.css('width', getComputedStyle(this.CropBox.el_)['left']);
  this.crop.rightFillDiv.css(
    'left',
    parseFloat(getComputedStyle(this.CropBox.el_)['left']) +
      parseFloat(getComputedStyle(this.CropBox.el_)['width']) +
      'px',
  );
  this.crop.rightFillDiv.css(
    'width',
    this.playerWidth -
      parseFloat(getComputedStyle(this.CropBox.el_)['left']) -
      parseFloat(getComputedStyle(this.CropBox.el_)['width']) +
      2 * this.crop.horizontalOffset +
      'px',
  );
  this.crop.topFillDiv.css('height', getComputedStyle(this.CropBox.el_)['top']);
  this.crop.topFillDiv.css('left', getComputedStyle(this.CropBox.el_)['left']);
  this.crop.topFillDiv.css('width', getComputedStyle(this.CropBox.el_)['width']);
  this.crop.bottomFillDiv.css(
    'top',
    parseFloat(getComputedStyle(this.CropBox.el_)['top']) +
      parseFloat(getComputedStyle(this.CropBox.el_)['height']) +
      'px',
  );
  this.crop.bottomFillDiv.css(
    'height',
    this.playerHeight -
      parseFloat(getComputedStyle(this.CropBox.el_)['top']) -
      parseFloat(getComputedStyle(this.CropBox.el_)['height']) +
      2 * this.crop.verticalOffset +
      'px',
  );
  this.crop.bottomFillDiv.css('left', getComputedStyle(this.CropBox.el_)['left']);
  this.crop.bottomFillDiv.css('width', getComputedStyle(this.CropBox.el_)['width']);
};

CropContainer.prototype.onMouseUp = function () {
  this.crop.draglock = false;
  this.resetCubeData();
};

CropContainer.prototype.resetCubeData = function () {
  var cube = this.getChild('CropBox').el_;
  this.crop.cubeHeight = $$(cube).height() - 20;
  this.crop.cubeWidth = $$(cube).width() - 20;
  this.crop.cubeOffsetLeft = $$(cube).offset().left;
  this.crop.cubeOffsetTop = $$(cube).offset().top;
  $$(cube).off('mousedown');
};

videojs.registerComponent('CropContainer', CropContainer);

var CropBox = videojs.extend(videojsComponent, {
  constructor: function constructor(player, options) {
    videojsComponent.call(this, player, options);
    this.on('mousedown', this.onMouseDown);
    this.on('mousemove', this.onMouseMove);
  },
});

CropBox.prototype.init_ = function () {
  this.el_.style['max-width'] = getComputedStyle(this.player_.el()).width;
  this.el_.style['max-height'] = getComputedStyle(this.player_.el()).height;
  this.crop = this.player_.crop;

  //default values
  if (!isDefined(this.crop.minWidth)) this.crop.minWidth = 50;
  if (!isDefined(this.crop.minHeight)) this.crop.minHeight = 50;
  if (!isDefined(this.crop.width)) this.crop.width = 75;
  if (!isDefined(this.crop.height)) this.crop.height = 75;
  if (!isDefined(this.crop.left)) this.crop.left = 12.5;
  if (!isDefined(this.crop.top)) this.crop.top = 12.5;

  if (parseInt(this.crop.width) + parseInt(this.crop.left) > 100) {
    this.crop.width = 75;
    this.crop.left = 12.5;
  }

  if (parseInt(this.crop.height) + parseInt(this.crop.top) > 100) {
    this.crop.height = 75;
    this.crop.top = 12.5;
  }

  var playerWidth = getComputedStyle(this.player_.el()).width;
  var playerHeight = getComputedStyle(this.player_.el()).height;

  var widthValue = (parseInt(playerWidth) * parseInt(this.crop.width)) / 100;
  var heightValue = (parseInt(playerHeight) * parseInt(this.crop.height)) / 100;
  var leftValue = (parseInt(playerWidth) * parseInt(this.crop.left)) / 100;
  var topValue = (parseInt(playerHeight) * parseInt(this.crop.top)) / 100;

  this.el_.style['min-width'] = this.crop.minWidth + 'px';
  this.el_.style['min-height'] = this.crop.minHeight + 'px';
  this.el_.style['width'] = widthValue - 2 * this.crop.horizontalOffset + 'px';
  this.el_.style['height'] = heightValue - 2 * this.crop.verticalOffset + 'px';
  this.el_.style['left'] = leftValue + this.crop.horizontalOffset + 'px';
  this.el_.style['top'] = topValue + this.crop.verticalOffset + 'px';
  this.el_.style['background-color'] = 'rgba(0,0,0,0)';

  this.crop.leftFillDiv.css('width', this.el_.style['left']);
  this.crop.rightFillDiv.css(
    'width',
    parseFloat(playerWidth) -
      parseFloat(this.el_.style['left']) -
      parseFloat(this.el_.style['width']) +
      'px',
  );
  this.crop.rightFillDiv.css(
    'left',
    parseFloat(this.el_.style['left']) + parseFloat(this.el_.style['width']) + 'px',
  );
  this.crop.topFillDiv.css('height', this.el_.style['top']);
  this.crop.topFillDiv.css('left', this.el_.style['left']);
  this.crop.topFillDiv.css('width', this.el_.style['width']);
  this.crop.bottomFillDiv.css(
    'top',
    parseFloat(this.el_.style['top']) + parseFloat(this.el_.style['height']) + 'px',
  );
  this.crop.bottomFillDiv.css(
    'height',
    parseFloat(playerHeight) -
      parseFloat(this.el_.style['top']) -
      parseFloat(this.el_.style['height']) +
      'px',
  );
  this.crop.bottomFillDiv.css('left', this.el_.style['left']);
  this.crop.bottomFillDiv.css('width', this.el_.style['width']);

  this.crop.cubeHeight = $$(this.el_).height() - 20;
  this.crop.cubeWidth = $$(this.el_).width() - 20;
  this.crop.cubeOffsetLeft = $$(this.el_).offset().left;
  this.crop.cubeOffsetTop = $$(this.el_).offset().top;
  this.crop.cubeTransformWidth = 0;
  this.crop.cubeTransformHeight = 0;
  this.crop.cubeCurrentHeight = 0;
  this.crop.cubeCurrentWidth = 0;
  this.crop.cubeCurrentLeft = 0;
  this.crop.cubeCurrentTop = 0;
  this.crop.currentDirection = '';
  this.crop.mousedownPointX = 0;
  this.crop.mousedownPointY = 0;
  this.crop.windowPointX = 0;
  this.crop.windowPointY = 0;
  this.crop.draglock = false;
};

CropBox.prototype.createEl = function () {
  return videojsComponent.prototype.createEl.call(this, 'div', {
    className: 'vjs-crop-box',
    innerHTML:
      '<span class="vjs-crop-box-top-left"></span>' +
      '<span class="vjs-crop-box-top-right"></span>' +
      '<span class="vjs-crop-box-bottom-right"></span>' +
      '<span class="vjs-crop-box-bottom-left"></span>',
  });
};

CropBox.prototype.onMouseDown = function () {
  $$(this.el_).css({
    cursor: 'default',
    'background-color': 'rgba(0,0,0,0)',
  });
};

CropBox.prototype.onMouseMove = function (event) {
  this.crop.cubeHeight = $$(this.el_).height() - 20;
  this.crop.cubeWidth = $$(this.el_).width() - 20;
  this.crop.cubeOffsetLeft = $$(this.el_).offset().left;
  this.crop.cubeOffsetTop = $$(this.el_).offset().top;
  var pointX = event.pageX - this.crop.cubeOffsetLeft;
  var pointY = event.pageY - this.crop.cubeOffsetTop;
  var that = this;
  $$(this.el_).off('mousedown');
  $$(this.el_).css({
    cursor: 'default',
    'background-color': 'rgba(0,0,0,0)',
  });

  if (pointX < 20 && pointY < 20) {
    $$(this.el_).css('cursor', 'nw-resize');
    $$(this.el_).on('mousedown', function (event) {
      that.crop.mousedownPointY = event.pageY;
      that.crop.mousedownPointX = event.pageX;
      that.crop.currentDirection = 'nw';
      that.crop.cubeCurrentHeight = $$(this).height();
      that.crop.cubeCurrentWidth = $$(this).width();
      that.crop.cubeCurrentTop = this.offsetTop | 0;
      that.crop.cubeCurrentLeft = this.offsetLeft | 0;
      that.crop.draglock = true;
    });
  } else if (pointX > this.crop.cubeWidth && pointY > this.crop.cubeHeight) {
    $$(this.el_).css('cursor', 'se-resize');
    $$(this.el_).on('mousedown', function (event) {
      that.crop.mousedownPointY = event.pageY;
      that.crop.mousedownPointX = event.pageX;
      that.crop.currentDirection = 'se';
      that.crop.cubeCurrentHeight = $$(this).height();
      that.crop.cubeCurrentWidth = $$(this).width();
      that.crop.cubeCurrentTop = this.offsetTop | 0;
      that.crop.cubeCurrentLeft = this.offsetLeft | 0;
      that.crop.draglock = true;
    });
  } else if (pointX < 20 && pointY > this.crop.cubeHeight) {
    $$(this.el_).css('cursor', 'sw-resize');
    $$(this.el_).on('mousedown', function (event) {
      that.crop.mousedownPointY = event.pageY;
      that.crop.mousedownPointX = event.pageX;
      that.crop.currentDirection = 'sw';
      that.crop.cubeCurrentHeight = $$(this).height();
      that.crop.cubeCurrentWidth = $$(this).width();
      that.crop.cubeCurrentTop = this.offsetTop | 0;
      that.crop.cubeCurrentLeft = this.offsetLeft | 0;
      that.crop.draglock = true;
    });
  } else if (pointX > this.crop.cubeWidth && pointY < 20) {
    $$(this.el_).css('cursor', 'ne-resize');
    $$(this.el_).on('mousedown', function (event) {
      that.crop.mousedownPointY = event.pageY;
      that.crop.mousedownPointX = event.pageX;
      that.crop.currentDirection = 'ne';
      that.crop.cubeCurrentHeight = $$(this).height();
      that.crop.cubeCurrentWidth = $$(this).width();
      that.crop.cubeCurrentTop = this.offsetTop | 0;
      that.crop.cubeCurrentLeft = this.offsetLeft | 0;
      that.crop.draglock = true;
    });
  } else if (pointX < 20 && pointY >= 20) {
    $$(this.el_).css('cursor', 'w-resize');
    $$(this.el_).on('mousedown', function (event) {
      that.crop.mousedownPointX = event.pageX;
      that.crop.currentDirection = 'w';
      that.crop.cubeCurrentHeight = $$(this).height();
      that.crop.cubeCurrentWidth = $$(this).width();
      that.crop.cubeCurrentTop = this.offsetTop | 0;
      that.crop.cubeCurrentLeft = this.offsetLeft | 0;
      that.crop.draglock = true;
    });
  } else if (pointY < 20 && pointX >= 20) {
    $$(this.el_).css('cursor', 'n-resize');
    $$(this.el_).on('mousedown', function (event) {
      that.crop.mousedownPointY = event.pageY;
      that.crop.currentDirection = 'n';
      that.crop.cubeCurrentHeight = $$(this).height();
      that.crop.cubeCurrentWidth = $$(this).width();
      that.crop.cubeCurrentTop = this.offsetTop | 0;
      that.crop.cubeCurrentLeft = this.offsetLeft | 0;
      that.crop.draglock = true;
    });
  } else if (pointX > this.crop.cubeWidth && pointY <= this.crop.cubeHeight) {
    $$(this.el_).css('cursor', 'e-resize');
    $$(this.el_).on('mousedown', function (event) {
      that.crop.mousedownPointX = event.pageX;
      that.crop.currentDirection = 'e';
      that.crop.cubeCurrentHeight = $$(this).height();
      that.crop.cubeCurrentWidth = $$(this).width();
      that.crop.cubeCurrentTop = this.offsetTop | 0;
      that.crop.cubeCurrentLeft = this.offsetLeft | 0;
      that.crop.draglock = true;
    });
  } else if (pointY > this.crop.cubeHeight && pointX <= this.crop.cubeWidth) {
    $$(this.el_).css('cursor', 's-resize');
    $$(this.el_).on('mousedown', function (event) {
      that.crop.mousedownPointY = event.pageY;
      that.crop.currentDirection = 's';
      that.crop.cubeCurrentHeight = $$(this).height();
      that.crop.cubeCurrentWidth = $$(this).width();
      that.crop.cubeCurrentTop = this.offsetTop | 0;
      that.crop.cubeCurrentLeft = this.offsetLeft | 0;
      that.crop.draglock = true;
    });
  } else {
    $$(this.el_).css({
      cursor: 'move',
    });
    $$(this.el_).on('mousedown', function (event) {
      that.crop.mousedownPointY = event.pageY;
      that.crop.mousedownPointX = event.pageX;
      that.crop.currentDirection = 'centered';
      that.crop.cubeCurrentHeight = $$(this).height();
      that.crop.cubeCurrentWidth = $$(this).width();
      that.crop.cubeCurrentTop = this.offsetTop | 0;
      that.crop.cubeCurrentLeft = this.offsetLeft | 0;
      that.crop.draglock = true;
    });
  }
};

function isDefined(data) {
  return typeof data != 'undefined' && data != null;
}

CropBox.prototype.onMouseUp = function () {};

videojs.registerComponent('CropBox', CropBox);

// Register the plugin with video.js.
registerPlugin('cropPlugin', cropPlugin);

// Include the version number.
cropPlugin.VERSION = version;

export default cropPlugin;
